/** Context used by Multiselect custom components.
 *
 * Used when certain props are not forwarded to custom components by react-select.
 */

import { createContext, useContext } from 'react';

/** Data available to Multiselect that does not get forwarded to custom components
 * through props.
 */
export interface ReactSelectContextData {
  required?: boolean;
}
/** Some props of react-select do not get forwarded to custom
 * components. Pass these props through in a context instead
 */
export const ReactSelectContext = createContext<ReactSelectContextData>({});

/** Custom hook to access ReactSelectContext */
export const useReactSelectContext = (): ReactSelectContextData => useContext(ReactSelectContext);
